.body {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 300px;
}

.navBtn {
  display: contents;
  cursor: pointer;
}
